import React from "react";

export default function P2Masthead() {
  return (
    <div className="polymer-masthead d-print-none">
      <div className="polymer-header-margin" />
      <div className="polymer-masthead-inner">
        <sgds-masthead></sgds-masthead>
      </div>
      <div className="polymer-header-margin" />
    </div>
  );
}
